package kz.dentalcrm.app.screens.patients.mvi

import kotlinx.collections.immutable.PersistentList
import kotlinx.collections.immutable.persistentListOf
import kz.dentalcrm.app.data.network.response_model.PatientData

data class PatientsViewState(
    val patients: PersistentList<PatientData> = persistentListOf(),
    val isLoading: Boolean = false,
    val error: String? = null,
    val searchQuery: String = "",
)
